import React, {Component} from "react";
import {ALL_PERIODS, getPeriodName} from "../../periods";
import { withTranslation } from 'react-i18next';

class PeriodsSelectClass extends Component {
    getOptions() {
        return this.props.periods !== undefined ? this.props.periods :  ALL_PERIODS;
    }

    render () {
        const { t } = this.props;
        const emptyOptionText = this.props.emptyOptionText !== undefined ? this.props.emptyOptionText : "";

        return (<select name={this.props.name}
                        onChange={this.props.onChange}
                        value={this.props.value}
                        disabled={this.props.disabled}
                        className={"form-select"}>
            <option className="select-empty-item" key='empty-option' value="">{emptyOptionText}</option>
            {this.getOptions().map((periodName) =>
                <option key={periodName} value={periodName}>{getPeriodName(periodName, t)}</option>
            )}
        </select>);
    }
}

export const PeriodsSelect = withTranslation()(PeriodsSelectClass);
export default PeriodsSelect;
